// پیمانکاران
import React, { useState, useEffect, useCallback, useRef } from 'react';
import ListPage, { ui } from '../../components/ListPage';
import { usePager, CountBadge } from '../../components/paging';
import JalaliDatePicker from '../../components/JalaliDatePicker';
import { useFormButtons } from '../../utils/vbPerms';
import { jsonOf, netErr } from '../../utils/http';
import ContractorBlackList from '../../components/ContractorBlackList';
import ContractorAccounts from '../../components/ContractorAccounts';

const toFa = n => String(n ?? '').replace(/[0-9]/g, d => '۰۱۲۳۴۵۶۷۸۹'[d]);

// آیتم‌های combo — نوع شخص، جنسیت، کد طبقه
const PERSON_KIND = ['', 'حقوقی', 'دولت جمهوری اسلامی ایران', 'خزانه داری کل کشور', 'نهادهای بین المللی',
  'حقیقی ایرانی با اهمیت', 'حقیقی ایرانی سایر', 'حقیقی خارجی با اهمیت', 'حقیقی خارجی سایر'];
const GENDER = ['مرد', 'زن'];
const CLASS_CODE = [
  'جزء طبقه',
  '3111 - پیمانکاران خصوصی طرح های تملک دارایی های سرمایه ای',
  '3112 - مشاوران حقوقی خصوصی طرح های تملک دارایی های سرمایه ای',
  '3113 - مشاوران حقیقی خصوصی طرح های تملک دارایی های سرمایه ای',
  '3121 - بانکهای خصوصی',
  '3122 - موسسات مالی و اعتباری خصوصی',
  '3131 - صندوق های بازنشستگی خصوصی',
  '3132 - شرکت های خصوصی',
  '3139 - سایر اشخاص حقوقی خصوصی',
  '3149 - رسمی',
  '3149 - پیمانی',
  '3149 - سایر',
  '3151 - سایر اشخاص حقیقی',
  '3211 - پیمانکاران دولتی طرح های تملک دارایی های سرمایه ای',
  '3212 - مشاوران دولتی طرح های تملک دارایی های سرمایه ای',
  '3221 - بانک مرکزی جمهوری اسلامی ایران',
  '3222 - سایر بانکهای دولتی',
  '3223 - موسسات مالی و اعتباری دولتی',
  '3231 - خزانه داری کل کشور',
  '3232 - وزارتخانه ها',
  '3233 - سازمان امور مالیاتی کشور',
  '3234 - سایر موسسات دولتی',
  '3235 - صندوق های بازنشستگی دولتی',
  '3236 - شرکت های دولتی',
  '3237 - دستگاههای اجرایی محلی',
  '3238 - دولت جمهوری اسلامی',
  '3239 - سایر اشخاص حقوقی دولتی',
  '3311 - سازمان تامین اجتماعی',
  '3312 - شهرداری ها',
  '3319 - سایر موسسات و نهادهای عمومی غیردولتی',
  '3411 - اشخاص حقوقی تعاونی',
  '3511 - نهادها و موسسات بین المللی',
  '3512 - شرکت های خارجی',
  '3519 - سایر اشخاص حقوقی خارجی',
  '3521 - اشخاص حقیقی خارجی',
  '3611 - سایر اشخاص حقیقی و حقوقی دارنده اوراق بدهی- اسناد خزانه اسلامی',
  '3612 - سایر اشخاص حقیقی و حقوقی دارنده اوراق بدهی- اوراق مشارکت',
  '3613 - سایر اشخاص حقیقی و حقوقی دارنده اوراق بدهی- صکوک اجاره',
  '3614 - سایر اشخاص حقیقی و حقوقی دارنده اوراق بدهی- اوراق قرضه',
  '3615 - سایر اشخاص حقیقی و حقوقی دارنده اوراق بدهی- صکوک مرابحه',
];

const EMPTY = {
  contractor_name: '', national_code: '', id_no: '', register_date: '', city_id: 0, city: '',
  address: '', postal_code: '', activity_subject: '', economy_code: '', class_code: 0,
  account_no: '', branch_code: 0, account_owner: '', tel_no: '', department_id: 0, department: '',
  manager: '', exchange_code: '', email: '', pay_id: '', person_kind: 0, father_name: '', gender: 0, remark: '',
};

const API = (path, opts = {}) => fetch(`/api/contract${path}`, {
  headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${localStorage.getItem('access')}` },
  ...opts,
}).then(jsonOf, netErr);

function Lookup({ label, value, endpoint, onPick, flex = 1, disabled }) {
  const [q, setQ] = useState('');
  const [rows, setRows] = useState([]);
  const [open, setOpen] = useState(false);
  const search = async (text) => {
    setQ(text);
    const j = await API(`${endpoint}?q=${encodeURIComponent(text)}`);
    if (j.ok) { setRows(j.rows); setOpen(true); }
  };
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '4px', flex, position: 'relative' }}>
      <label style={ui.mlabel}>{label}</label>
      <input value={value || q} onFocus={() => !disabled && search(q)} onChange={e => !disabled && search(e.target.value)}
        placeholder="جستجو..." disabled={disabled} style={{ ...ui.input, background: disabled ? '#f2f2f2' : '#fff' }} />
      {value && !disabled && <button onClick={() => { onPick({ id: 0, display: '' }); setQ(''); }}
        style={{ position: 'absolute', left: '6px', top: '30px', border: 'none', background: 'transparent', cursor: 'pointer', color: '#c62828', fontSize: '14px' }}>✕</button>}
      {open && rows.length > 0 && (
        <div style={{ position: 'absolute', top: '100%', right: 0, left: 0, background: '#fff', border: '1px solid #e0e0e0',
          borderRadius: '8px', boxShadow: '0 8px 24px rgba(0,0,0,0.15)', zIndex: 700, maxHeight: '240px', overflowY: 'auto', marginTop: '2px' }}>
          {rows.map(r => (
            <div key={r.id} onClick={() => { onPick(r); setOpen(false); setQ(''); }}
              style={{ padding: '8px 10px', cursor: 'pointer', fontSize: '12px', borderBottom: '1px solid #f0f0f0' }}
              onMouseEnter={e => e.currentTarget.style.background = '#e8f0fe'}
              onMouseLeave={e => e.currentTarget.style.background = '#fff'}>{r.display}</div>
          ))}
        </div>
      )}
    </div>
  );
}

function TInput({ label, val, onCh, flex = 1, type = 'text' }) {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '4px', flex }}>
      <label style={ui.mlabel}>{label}</label>
      <input type={type} value={val} onChange={e => onCh(e.target.value)} style={ui.input} />
    </div>
  );
}

function TSelect({ label, val, onCh, items, flex = 1 }) {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '4px', flex }}>
      <label style={ui.mlabel}>{label}</label>
      <select value={val} onChange={e => onCh(Number(e.target.value))} style={ui.input}>
        {items.map((m, i) => <option key={i} value={i}>{m || '—'}</option>)}
      </select>
    </div>
  );
}

export default function ContractorList({ user, onBack }) {
  // دکمه‌های فرم FRMCONTRACTOR — دیدن دکمه = داشتن مجوز
  const vbf = useFormButtons('FRMCONTRACTOR', ["BTNNEW","BTNEDIT","BTNDELETE","BTNOK","BTNBLACKLIST","BTNCONTRACTORACCOUNT"]);
  const [blackList, setBlackList] = useState(null);
  /* حساب‌های پیمانکار و پیشنهاد ثبت حساب برای پیمانکار بدون حساب */
  const [accounts, setAccounts] = useState(null);
  const [accountAsk, setAccountAsk] = useState(null);
  const accountNecessary = useRef(true);
  const [data, setData]         = useState([]);
  const pager = usePager();          // صفحه‌بندی مشترک — ۲۰۰ ردیف در هر صفحه
  const [search, setSearch]     = useState('');
  const [selected, setSelected] = useState(null);
  const [loading, setLoading]   = useState(false);
  const [modal, setModal]       = useState(null);
  const [form, setForm]         = useState(EMPTY);
  const [saving, setSaving]     = useState(false);
  const [error, setError]       = useState('');
  const [toast, setToast]       = useState('');
  const [tab, setTab]           = useState('main');

  const showToast = m => { setToast(m); setTimeout(() => setToast(''), 3000); };

  const openAccounts = (autoNew = false) => {
    if (!selected || !vbf.can('BTNCONTRACTORACCOUNT')) return;
    setAccounts({ code: (selected?.contractor_code || selected?.id), name: selected.contractor_name, contract: 0, title: '', autoNew });
  };
  // پیمانکاری که هنوز شماره حساب ندارد: فقط به کسی که اجازهٔ ثبت حساب دارد پیشنهاد می‌شود
  useEffect(() => {
    if (!selected || !accountNecessary.current || !vbf.can('BTNCONTRACTORACCOUNT')) return;
    let alive = true;
    API(`/contractor-accounts/need/?contractor=${(selected?.contractor_code || selected?.id) || 0}&contract=${0 || 0}`).then(j => {
      if (alive && j.ok && j.missing && j.can_new && accountNecessary.current) setAccountAsk(selected.id);
    });
    return () => { alive = false; };
  }, [selected?.id]); // eslint-disable-line


  const cols = [
    { h: 'نوع شخص', k: 'person_kind', w: 130, right: true, map: PERSON_KIND },
    { h: 'عنوان پیمانکار', k: 'contractor_name', w: 220, right: true },
    { h: 'شناسه ملی', k: 'national_code', w: 110, mono: true },
    { h: 'کد اقتصادی', k: 'economy_code', w: 110, mono: true },
    { h: 'موضوع فعالیت', k: 'activity_subject', w: 160, right: true },
    { h: 'شماره حساب', k: 'account_no', w: 170, mono: true },
    { h: 'بانک', k: 'bank', w: 180, right: true },
    { h: 'تلفن', k: 'tel_no', w: 100, mono: true },
    { h: 'نماینده', k: 'manager', w: 120, right: true },
    { h: 'واحد', k: 'department', w: 120, right: true },
    { h: 'محل ثبت', k: 'city', w: 110, right: true },
    { h: 'قرارداد', k: 'contract_count', w: 70, cnt: true },
    { h: 'اسناد', k: 'document_count', w: 70, cnt: true },
    { h: 'حواله', k: 'havaleh_count', w: 70, cnt: true },
    { h: 'لیست سیاه', k: 'blacklist_count', w: 80, black: true },
    { h: 'آدرس', k: 'address', w: 220, right: true },
  ];
  const [colW, setColW] = useState(cols.map(c => c.w));
  const colWRef = useRef(colW);
  useEffect(() => { colWRef.current = colW; }, [colW]);
  const startResize = useCallback((idx, e) => {
    e.preventDefault(); e.stopPropagation();
    const sx = e.clientX, sw = colWRef.current[idx];
    const onMove = ev => setColW(w => { const n = [...w]; n[idx] = Math.max(40, sw + (sx - ev.clientX)); return n; });
    const onUp = () => { document.removeEventListener('mousemove', onMove); document.removeEventListener('mouseup', onUp); };
    document.addEventListener('mousemove', onMove); document.addEventListener('mouseup', onUp);
  }, []);

  const load = useCallback(async (pg = 1, sr = search) => {
    setLoading(true); setError(''); if (pg === 1) setSelected(null);
    const j = await API(`/contractors/?page=${pg}&search=${encodeURIComponent(sr)}`);
    setLoading(false);
    if (j.ok) {
      setData(prev => pager.merge(prev, j, pg));
    } else setError(j.msg);
  }, [search]);

  useEffect(() => { load(1, ''); }, []);   // eslint-disable-line

  const F = (k, v) => setForm(f => ({ ...f, [k]: v }));
  const openNew  = () => { if (!vbf.can('BTNNEW')) return; setForm(EMPTY); setError(''); setTab('main'); setModal('new'); };
  const openEdit = () => { if (!vbf.can('BTNEDIT')) return; if (!selected) return; setForm({ ...EMPTY, ...selected }); setError(''); setTab('main'); setModal('edit'); };
  const openDel  = () => { if (!vbf.can('BTNDELETE')) return; if (selected) setModal('delete'); };

  const save = async () => {
    setSaving(true); setError('');
    const j = modal === 'new'
      ? await API('/contractors/create/', { method: 'POST', body: JSON.stringify(form) })
      : await API(`/contractors/${selected.id}/update/`, { method: 'PUT', body: JSON.stringify(form) });
    setSaving(false);
    if (j.ok) { setModal(null); setSelected(null); showToast(j.msg); load(1); }
    else setError(j.msg);
  };

  const doDelete = async () => {
    setSaving(true);
    const j = await API(`/contractors/${selected.id}/delete/`, { method: 'DELETE' });
    setSaving(false);
    if (j.ok) { setModal(null); setSelected(null); showToast('حذف شد'); load(1); }
    else { setError(j.msg); setModal(null); }
  };

  const toolbar = (
    <>
      <div style={ui.toolBtns}>
        {vbf.can('BTNNEW') && <button onClick={openNew} style={ui.btnNew}>＋ جدید</button>}
        {vbf.can('BTNEDIT') && <button onClick={openEdit} disabled={!selected} style={{ ...ui.btnEdit, opacity: selected ? 1 : 0.4, cursor: selected ? 'pointer' : 'default' }}>✎ ویرایش</button>}
        {vbf.can('BTNDELETE') && <button onClick={openDel} disabled={!selected} style={{ ...ui.btnDel, opacity: selected ? 1 : 0.4, cursor: selected ? 'pointer' : 'default' }}>✕ حذف</button>}
        {vbf.can('BTNBLACKLIST') && <button onClick={() => selected && setBlackList({ code: selected.contractor_code, name: selected.contractor_name })}
          disabled={!selected} style={{ ...ui.btnDel, background: 'linear-gradient(135deg,#7f0000,#c62828)', opacity: selected ? 1 : 0.4 }}>⛔ Black List</button>}
        {vbf.can('BTNCONTRACTORACCOUNT') && <button onClick={() => openAccounts(false)} disabled={!selected}
          style={{ ...ui.btnEdit, background: 'linear-gradient(135deg,#4527a0,#5e35b1)', opacity: selected ? 1 : 0.4 }}>🏦 حساب پیمانکار</button>}
      </div>
      <input value={search} onChange={e => setSearch(e.target.value)} onKeyDown={e => e.key === 'Enter' && load(1, search)}
        style={{ ...ui.searchInput, flex: 1, minWidth: '180px' }} placeholder="جستجو (نام، شناسه ملی، کد اقتصادی، حساب، تلفن)..." />
      <button onClick={() => load(1, search)} style={ui.btnEdit}>🔍 جستجو</button>
      {loading && <span>⏳</span>}
      <CountBadge shown={data.length} total={pager.total} loading={loading} />
    </>
  );

  
  const cell = (r, c, sel) => {
    const tc = sel ? '#fff' : '#111';
    if (c.cnt)   return <td style={{ ...ui.td, color: sel ? '#fff' : r[c.k] ? '#1a237e' : '#ccc', fontWeight: '600' }}>{r[c.k] ? toFa(r[c.k]) : '•'}</td>;
    if (c.black) return <td style={{ ...ui.td, color: sel ? '#fff' : r[c.k] ? '#b71c1c' : '#ccc', fontWeight: '700' }}>{r[c.k] ? toFa(r[c.k]) : '•'}</td>;
    if (c.mono)  return <td style={{ ...ui.td, fontFamily: 'monospace', fontSize: '11px', color: tc }}>{r[c.k] || '•'}</td>;
    const txt = c.map ? (c.map[r[c.k]] || '') : r[c.k];
    return <td style={{ ...ui.td, textAlign: c.right ? 'right' : 'center', fontSize: '11px', color: tc, overflow: 'hidden', textOverflow: 'ellipsis' }} title={txt}>{txt || '•'}</td>;
  };

  return (
    <>
      <ListPage user={user} onBack={onBack} title="پیمانکاران" subtitle="بخش قراردادها — سامانه ارجان"
        toolbar={toolbar} error={!modal ? error : ''} pager={pager} loading={loading} onMore={p => load(p, search)}>
        <table style={{ ...ui.table, tableLayout: 'fixed' }}>
          <thead style={{ position: 'sticky', top: 0, zIndex: 10 }}>
            <tr>
              {cols.map((c, i) => (
                <th key={i} style={{ ...ui.th, width: colW[i], minWidth: 40, position: 'relative', userSelect: 'none' }}>
                  {c.h}<span onMouseDown={e => startResize(i, e)} style={{ position: 'absolute', left: 0, top: 0, bottom: 0, width: '4px', cursor: 'col-resize' }} />
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {data.map((r, i) => {
              const sel = selected?.id === r.id;
              const bg  = sel ? '#1a2f50' : i % 2 === 0 ? '#fff' : '#fdf6e3';
              return (
                <tr key={r.id} style={{ background: bg, cursor: 'pointer' }}
                  onClick={() => setSelected(sel ? null : r)} onDoubleClick={() => { setSelected(r); setTimeout(openEdit, 0); }}
                  onMouseEnter={e => { if (!sel) e.currentTarget.style.background = '#e8f0fe'; }}
                  onMouseLeave={e => { if (!sel) e.currentTarget.style.background = bg; }}>
                  {cols.map((c, ci) => <React.Fragment key={ci}>{cell(r, c, sel)}</React.Fragment>)}
                </tr>
              );
            })}
          </tbody>
        </table>
        {!loading && data.length === 0 && <div style={ui.empty}>📭 پیمانکاری یافت نشد</div>}
      </ListPage>

      {(modal === 'new' || modal === 'edit') && (
        <div style={ui.overlay} onClick={() => setModal(null)}>
          <div style={{ ...ui.modal, maxWidth: '820px' }} onClick={e => e.stopPropagation()}>
            <div style={ui.mHeader}>
              <div style={ui.mTitle}>{modal === 'new' ? '＋ پیمانکار جدید' : `✎ ویرایش ${form.contractor_name}`}</div>
              <button onClick={() => setModal(null)} style={ui.closeBtn}>✕</button>
            </div>

            <div style={{ display: 'flex', gap: '4px', padding: '8px 16px 0', background: '#f8f9fa', flexWrap: 'wrap' }}>
              {[['main', 'اطلاعات اصلی'], ['contact', 'ثبت و تماس'], ['account', 'حساب و مالی']].map(([k, t]) => (
                <button key={k} onClick={() => setTab(k)}
                  style={{ padding: '7px 14px', border: 'none', borderRadius: '8px 8px 0 0', cursor: 'pointer',
                    fontFamily: 'inherit', fontSize: '12px', fontWeight: '700',
                    background: tab === k ? '#fff' : 'transparent', color: tab === k ? '#4a148c' : '#888',
                    borderBottom: tab === k ? '2px solid #4a148c' : '2px solid transparent' }}>{t}</button>
              ))}
            </div>

            <div style={ui.mBody}>
              {error && <div style={ui.errBox}>⚠️ {error}</div>}

              {tab === 'main' && (<>
                <div style={ui.row}>
                  <div style={{ display: 'flex', flexDirection: 'column', gap: '4px', flex: 2 }}>
                    <label style={ui.mlabel}>عنوان پیمانکار</label>
                    <input value={form.contractor_name} onChange={e => F('contractor_name', e.target.value)} style={ui.input} />
                  </div>
                </div>
                <div style={ui.row}>
                  <TInput label="شناسه ملی" val={form.national_code} onCh={v => F('national_code', v)} />
                  <TInput label="کد اقتصادی" val={form.economy_code} onCh={v => F('economy_code', v)} />
                  <TInput label="نام پدر" val={form.father_name} onCh={v => F('father_name', v)} />
                  <TSelect label="جنسیت" val={form.gender} onCh={v => F('gender', v)} items={GENDER} flex={0.7} />
                </div>
                <div style={ui.row}>
                  <TSelect label="نوع شخص" val={form.person_kind} onCh={v => F('person_kind', v)} items={PERSON_KIND} />
                </div>
                <div style={ui.row}>
                  <TSelect label="جزء طبقه (پروتکل)" val={form.class_code} onCh={v => F('class_code', v)} items={CLASS_CODE} flex={2} />
                </div>
                <div style={ui.row}>
                  <div style={{ display: 'flex', flexDirection: 'column', gap: '4px', flex: 1 }}>
                    <label style={ui.mlabel}>موضوع فعالیت</label>
                    <input value={form.activity_subject} onChange={e => F('activity_subject', e.target.value)} style={ui.input} />
                  </div>
                </div>
              </>)}

              {tab === 'contact' && (<>
                <div style={ui.row}>
                  <TInput label="شماره ثبت" val={form.id_no} onCh={v => F('id_no', v)} />
                  <div style={{ display: 'flex', flexDirection: 'column', gap: '4px', flex: 1 }}>
                    <label style={ui.mlabel}>تاریخ ثبت</label>
                    <JalaliDatePicker value={form.register_date} onChange={v => F('register_date', v)} placeholder="تاریخ ثبت" />
                  </div>
                  <Lookup label="محل ثبت" value={form.city} endpoint="/contractors/lookup/city/"
                    onPick={r => setForm(f => ({ ...f, city_id: r.id, city: r.display }))} />
                </div>
                <div style={ui.row}>
                  <TInput label="تلفن" val={form.tel_no} onCh={v => F('tel_no', v)} />
                  <TInput label="کد پستی" val={form.postal_code} onCh={v => F('postal_code', v)} />
                  <TInput label="ایمیل" val={form.email} onCh={v => F('email', v)} />
                </div>
                <div style={ui.row}>
                  <TInput label="نماینده" val={form.manager} onCh={v => F('manager', v)} />
                  <Lookup label="واحد" value={form.department} endpoint="/contractors/lookup/department/"
                    onPick={r => setForm(f => ({ ...f, department_id: r.id, department: r.display }))} />
                </div>
                <div style={ui.row}>
                  <div style={{ display: 'flex', flexDirection: 'column', gap: '4px', flex: 1 }}>
                    <label style={ui.mlabel}>آدرس</label>
                    <input value={form.address} onChange={e => F('address', e.target.value)} style={ui.input} />
                  </div>
                </div>
              </>)}

              {tab === 'account' && (<>
                <div style={ui.row}>
                  <TInput label="شماره حساب (شبا)" val={form.account_no} onCh={v => F('account_no', v)} flex={2} />
                  <TInput label="صاحب حساب" val={form.account_owner} onCh={v => F('account_owner', v)} />
                </div>
                {form.bank && <div style={{ fontSize: '11px', color: '#888', marginTop: '-6px', marginBottom: '8px' }}>بانک: {form.bank}</div>}
                <div style={ui.row}>
                  <TInput label="شناسه پرداخت" val={form.pay_id} onCh={v => F('pay_id', v)} />
                  <TInput label="کد بورس" val={form.exchange_code} onCh={v => F('exchange_code', v)} />
                </div>
                <div style={ui.row}>
                  <div style={{ display: 'flex', flexDirection: 'column', gap: '4px', flex: 1 }}>
                    <label style={ui.mlabel}>توضیح</label>
                    <input value={form.remark} onChange={e => F('remark', e.target.value)} style={ui.input} />
                  </div>
                </div>
              </>)}
            </div>

            <div style={ui.mFooter}>
              <button onClick={() => { setModal(null); setError(''); }} style={ui.btnCancel}>انصراف</button>
              {vbf.can('BTNOK') && <button onClick={save} disabled={saving} style={ui.btnSave}>{saving ? '⏳ ...' : '💾 ذخیره'}</button>}
            </div>
          </div>
        </div>
      )}

      {modal === 'delete' && (
        <div style={ui.overlay} onClick={() => setModal(null)}>
          <div style={{ ...ui.modal, maxWidth: '440px' }} onClick={e => e.stopPropagation()}>
            <div style={{ ...ui.mHeader, background: 'linear-gradient(135deg,#b71c1c,#c62828)' }}>
              <div style={ui.mTitle}>⚠️ تأیید حذف</div>
              <button onClick={() => setModal(null)} style={ui.closeBtn}>✕</button>
            </div>
            <div style={{ ...ui.mBody, textAlign: 'center', padding: '26px' }}>
              <div style={{ fontSize: '34px', marginBottom: '10px' }}>🗑️</div>
              {selected?.contractor_name}<br />شناسه ملی {toFa(selected?.national_code)}
            </div>
            <div style={ui.mFooter}>
              <button onClick={() => setModal(null)} style={ui.btnCancel}>خیر</button>
              {vbf.can('BTNDELETE') && <button onClick={doDelete} disabled={saving} style={{ ...ui.btnSave, background: '#b71c1c' }}>{saving ? '⏳...' : 'بله، حذف'}</button>}
            </div>
          </div>
        </div>
      )}

      {blackList && <ContractorBlackList contractorCode={blackList.code} contractorName={blackList.name}
        onClose={() => setBlackList(null)} />}
      {accounts && <ContractorAccounts contractorCode={accounts.code} contractorName={accounts.name}
        contractId={accounts.contract} contractTitle={accounts.title} autoNew={accounts.autoNew}
        onChanged={m => showToast(m)} onClose={() => { setAccounts(null); load(1); }} />}
      {accountAsk && selected?.id === accountAsk && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(10,22,40,.45)', zIndex: 100400, display: 'flex',
          alignItems: 'center', justifyContent: 'center', direction: 'rtl' }}>
          <div style={{ background: '#fff', borderRadius: 12, padding: '18px 22px', maxWidth: 440, width: '100%',
            boxShadow: '0 20px 60px rgba(0,0,0,.3)', fontFamily: "'Vazirmatn',Tahoma,sans-serif" }}>
            <div style={{ fontWeight: 700, color: '#4527a0', marginBottom: 6 }}>انتخاب کنید</div>
            <div style={{ fontSize: 14, marginBottom: 16 }}>شماره حساب پیمانکار ثبت نشده است</div>
            <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', justifyContent: 'flex-end' }}>
              <button onClick={() => { setAccountAsk(null); openAccounts(true); }}
                style={{ ...ui.btnSave, background: '#4527a0' }}>شماره حساب را الان ثبت میکنم</button>
              <button onClick={() => setAccountAsk(null)} style={ui.btnEdit}>بعداً یادآوری کن</button>
              <button onClick={() => { accountNecessary.current = false; setAccountAsk(null); }}
                style={{ ...ui.btnEdit, background: '#78909c' }}>دیگر این پیام را نشان نده</button>
            </div>
          </div>
        </div>)}
      {toast && <div style={ui.toast}>{toast}</div>}
    </>
  );
}
